import React from 'react'

import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { StockView } from './StockView'
import { ShippingsView } from './ShippingsView'


const paperStyle = {
    marginTop: 100,
    paddingBottom: 50,
    paddingTop: 25,
    padding: 20,
    width: '100%',
    textAlign: 'left',
    display: 'inline-block',
};



class LogisticView extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            tab: 0,

        }
        this.handleClick = this.handleClick.bind(this);
        this.changeTab = this.changeTab.bind(this);
    }

    handleClick(e) {
        this.setState({ open: true });
    }



    changeTab(event, value) {
        this.setState({ tab: value });
    }


    render(){
        return (
            <Paper style={paperStyle}>
                <Tabs
                    value={this.state.tab}
                    onChange={this.changeTab}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Catalogo" />
                    <Tab label="Pedidos" />
                </Tabs>
                {this.state.tab === 0 && <StockView />}
            </Paper>

        )
    }
}

export default LogisticView


// WEBPACK FOOTER //
// ./src/components/Logistic/LogisticView.js